import React, { useState, useCallback, useEffect } from 'react';
import { Container, Grid } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import useFirebase from '../Firebase';
import { useAuthentication } from '../Session';
import { useConfirmation } from '../Dialog/useConfirmation';
import LoadingScreen from '../Loading';
import useStyles from './styles.js';
import TranscriptCard from './TranscriptCard';
import NewTranscriptCard from './NewTranscriptCard';
import * as ROUTES from '../../constants/routes';

const TranscriptsList = () => {
  const classes = useStyles();
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [transcripts, setTranscripts] = useState([]);
  const authUser = useAuthentication();
  const [canCreateMoreTranscripts, setCanCreateMoreTranscripts] = useState(
    false
  );
  const firebase = useFirebase();
  const confirm = useConfirmation();

  const getTranscripts = useCallback(() => {
    setLoading(true);
    console.debug(`loading transcripts of user ${authUser.uid} now`);
    return firebase.transcripts(authUser.uid).onSnapshot(snapshot => {
      if (snapshot.empty) {
        console.debug(`snapshot is empty`);
        setTranscripts([]);
        setLoading(false);
        return;
      }
      const transcriptList = snapshot.docs.map(doc => {
        console.debug(`transcript: ${JSON.stringify(doc.data)}`);
        return {
          ...doc.data(),
          id: doc.id
        };
      });
      console.debug(`transcript List: ${JSON.stringify(transcriptList)}`);
      setTranscripts(transcriptList);
      setLoading(false);
    });
  }, [firebase, authUser]);

  useEffect(() => {
    console.debug(
      `before loading transcript list, authUser: ${JSON.stringify(authUser)}`
    );
    if (authUser.authenticated) {
      let unsubscribe = getTranscripts();
      return () => unsubscribe();
    }
  }, [getTranscripts, authUser]);

  useEffect(() => {
    if (authUser.authenticated) {
      if (authUser.plan === 'free') {
        setCanCreateMoreTranscripts(transcripts.length < 3);
      } else if (authUser.plan === 'premium') {
        setCanCreateMoreTranscripts(true);
      }
    } else {
      setCanCreateMoreTranscripts(false);
    }
  }, [authUser, transcripts]);

  const handleDeleteTranscript = useCallback(
    docId => () => {
      console.debug(`delete transcript called`);
      confirm({
        variant: 'danger',
        catchOnCancel: true,
        title: 'Are you sure you want to delete this Transcript?',
        description: 'Once deleted, the data cannot be recovered later.'
      })
        .then(() => firebase.deleteTranscript(docId))
        .then(() => {
          setTranscripts(t => t.filter(t => t.id !== docId));
        });
    },
    [firebase, confirm]
  );

  const renderLoading = () => <LoadingScreen open={loading} />;

  const renderTranascriptList = () => (
    <Container maxWidth="lg" className={classes.container}>
      <Grid container spacing={2}>
        <Grid item xs={10} lg={4} md={4} sm={6}>
          <NewTranscriptCard disabled={!canCreateMoreTranscripts} />
        </Grid>
        {transcripts.map(t => (
          <Grid key={t.id} item xs={10} lg={4} md={4} sm={6}>
            <TranscriptCard
              id={t.id}
              name={t.name}
              length={t.length || 0}
              countSpeaker={t.speakerCount}
              language={t.language}
              handleDelete={handleDeleteTranscript(t.id)}
              openTranscript={() =>
                history.push(ROUTES.transcriptEditorById(t.id))
              }
              {...t}
            />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
  return loading ? renderLoading() : renderTranascriptList();
};
export default TranscriptsList;
